module.exports = __webpack_public_path__ + "img/BatRider.020c8548.png";